import { useEffect, useState, useRef, useCallback } from "react";
import { createPortal } from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSort, faSortUp, faSortDown } from "@fortawesome/free-solid-svg-icons";
import { LuListFilter } from "react-icons/lu";
import styles from "../../styles/patient-page-modules/careManagerDashboard.module.css";

const sortOptions = [
  { value: "rpm", label: "RPM" },
  { value: "ccm", label: "CCM" },
];

const TimeSortDropdown = ({ sortConfig, setSortConfig, sortType, sortDirection }) => {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const btnRef = useRef(null);
  const dropRef = useRef(null);

  const activeType = sortType || "rpm";
  const isActiveColumn = sortConfig.key === "time_column";

  const toggle = (e) => {
    e.stopPropagation();
    if (!open && btnRef.current) {
      const rect = btnRef.current.getBoundingClientRect();
      setPos({ top: rect.bottom + 4, left: rect.left });
    }
    setOpen((v) => !v);
  };

  const close = useCallback(() => setOpen(false), []);

  useEffect(() => {
    if (!open) return;

    const handleOutsideClick = (e) => {
      if (
        btnRef.current && !btnRef.current.contains(e.target) &&
        dropRef.current && !dropRef.current.contains(e.target)
      ) {
        close();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    window.addEventListener("scroll", close, true);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      window.removeEventListener("scroll", close, true);
    };
  }, [open, close]);

  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
      <button
        ref={btnRef}
        type="button"
        onClick={toggle}
        className={`${styles.timeSortHeaderButton} ${isActiveColumn ? styles.timeSortHeaderButtonActive : ""}`}
      >
        <span style={{ fontWeight: 700 }}>Time (hr:mm:ss)</span>
        <LuListFilter size={16} />
      </button>

      {open && createPortal(
        <div
          ref={dropRef}
          className={styles.timeSortPopover}
          style={{ position: "fixed", top: pos.top, left: pos.left, zIndex: 9999 }}
        >
          <div className={styles.timeSortPopoverHeader}>
            <span className={styles.timeSortPopoverTitle}>Time sorting</span>
            <button
              type="button"
              className={styles.timeSortPopoverCloseBtn}
              onClick={close}
              aria-label="Close"
            >
              ×
            </button>
          </div>

          <div className={styles.timeSortOptionsContainer}>
            {sortOptions.map((option) => {
              const isSelected = isActiveColumn && activeType === option.value;
              const nextDirection =
                isSelected
                  ? sortDirection === "asc" ? "desc" : "asc"
                  : "asc";

              const icon = isSelected
                ? sortDirection === "asc" ? faSortUp : faSortDown
                : faSort;

              return (
                <button
                  key={option.value}
                  type="button"
                  className={`${styles.timeSortOption} ${isSelected ? styles.timeSortOptionActive : ""}`}
                  onClick={() => {
                    setSortConfig({
                      key: "time_column",
                      direction: nextDirection,
                      extra: { type: option.value },
                    });
                    close();
                  }}
                >
                  <span>{option.label}</span>
                  <FontAwesomeIcon icon={icon} className={styles.timeSortOptionIcon} />
                </button>
              );
            })}
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

export default TimeSortDropdown;
